module.exports = __webpack_public_path__ + "static/img/硕士_2023_乔雨晴_yqdveoo@126.com.a9f80b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/members/硕士_2023_乔雨晴_yqdveoo@126.com.jpg
// module id = j+CH
// module chunks = 6